import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ri-resolution-ui-panel-content',
  template: `<ng-content />`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PanelContentComponent {}
